<shared-modal-type-dynamic-height [modalData]="modalData" [center]="true" [mobilePreserve]="true" [size]="size"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-delivery-not-available">

    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-delivery-not-available__sub-h">
        DELIVERY NOT AVAILABLE FROM
    </shared-header>
    <shared-header [center]="true" class="modal-for-delivery-not-available__h" type="2" marginTop="xs"
        marginBottom="md">
        {{locationName$ | async}}
    </shared-header>

    <div class="modal-for-delivery-not-available__content">
        The selected address is outside of the<br />
        delivery area of the selected location. <br />
        Don’t worry you can still order pick up!<br />

        <shared-link class="modal-for-delivery-not-available__link" (onClick)="handleViewOtherStoresClick($event)"
            [emphasis]="false">Try another address</shared-link>
    </div>

    <div class="modal-for-delivery-not-available__actions">
        <ng-template #twoColumnsLeft>
            <shared-btn feel="secondary" [width]="'extended'" size="lg" (onClick)="handleViewOtherStoresClick($event)">
                View other stores
            </shared-btn>
        </ng-template>

        <ng-template #twoColumnsRight>
            <shared-btn [width]="'extended'" size="lg" (onClick)="handlePickUpClick($event)">
                Pick up instead
            </shared-btn>
        </ng-template>

        <shared-two-columns [left]="twoColumnsLeft" [right]="twoColumnsRight"></shared-two-columns>
    </div>

</shared-modal-type-dynamic-height>